var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.406 16.404H3.65596V8.08799H2.88196V3.59599H17.118V8.08799H16.406V16.404ZM4.05596 16.004H16.004V7.68799H16.716V3.99599H3.28196V7.68799H4.05596V16.004Z",
    fill: "#091E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49597 7.674V15.564H15.566V7.674H4.49597ZM12.45 10.622H7.54997V9.378H12.45V10.622Z",
    fill: "#091E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72205 4.43401V7.24801H4.42005H15.642H16.278V4.43401H3.72205Z",
    fill: "#091E0E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOutlined);
export default __webpack_public_path__ + "static/media/BoxOutlined.7c4706a050dc2cda5625cb7f9f0c93b0.svg";
export { ForwardRef as ReactComponent };